exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._9oYzQi8G97qc2y4KKSJ-v{width:72px;height:72px;line-height:72px}html[dir] ._9oYzQi8G97qc2y4KKSJ-v{border-radius:50%;text-align:center}._2mu1rdlir3q_CR1rkYX6Ws{font-size:24px}", ""]);

// exports
exports.locals = {
	"cardIconContainer": "_9oYzQi8G97qc2y4KKSJ-v",
	"cardIcon": "_2mu1rdlir3q_CR1rkYX6Ws"
};